import { z } from 'zod'

export const DashboardDiagnosticTriggerRequestSchema = z.object({
  schoolClassroomId: z.number(),
  triggerTime: z.string().datetime()
})

export type DashboardDiagnosticTriggerRequestEntity = z.infer<
  typeof DashboardDiagnosticTriggerRequestSchema
>
